/**
 * @generated SignedSource<<50d430c51e0ca0397d221265cfdf562c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteMemberUser_Mutation$variables = Record<PropertyKey, never>;
export type DeleteMemberUser_Mutation$data = {
  readonly responsePayload: {
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string | null | undefined;
    } | null | undefined>;
    readonly success: boolean;
  } | null | undefined;
};
export type DeleteMemberUser_Mutation = {
  response: DeleteMemberUser_Mutation$data;
  variables: DeleteMemberUser_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteMemberUser_Mutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": null,
        "concreteType": "DeleteMemberUserPayload",
        "kind": "LinkedField",
        "name": "deleteMemberUser",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DeleteMemberUser_Mutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": null,
        "concreteType": "DeleteMemberUserPayload",
        "kind": "LinkedField",
        "name": "deleteMemberUser",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6b5a2bb1a69dae7c45f236727b9a24c7",
    "id": null,
    "metadata": {},
    "name": "DeleteMemberUser_Mutation",
    "operationKind": "mutation",
    "text": "mutation DeleteMemberUser_Mutation {\n  responsePayload: deleteMemberUser {\n    success\n    errors {\n      __typename\n      code\n      message\n      field\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2dc5135cfbe330a05ea8e759b15688ca";

export default node;
